import { useEffect } from 'react'
import { formatPrice } from 'sidecar-utility-library'
import { getAuthedUser } from 'sidecar-utilities'
import {
  getBenefitLimit,
  getBenefitUsed,
  doesBenefitExist,
} from 'sidecar-member-components/utils'

export const useHeap = () => {
  const authedUser = getAuthedUser()
  const policy = authedUser?.policy || {}

  useEffect(() => {
    if (!window.heap) return

    const collectedData = {
      relationToPrimary: authedUser.primary ? 'PRIMARY' : 'DEPENDENT',
      groupUuid: authedUser?.group?.uuid,
      householdPolicyUuid: policy?.parentPolicy?.uuid,
      policyUuid: policy?.uuid,
      policyCoverageStatus: policy?.coverageStatus,
      policyStatus: policy?.status,
      planName: authedUser?.planTitle,
      policyLocation: policy?.address?.state,
      prescriptionCoverage: doesBenefitExist(policy, 'PRESCRIPTIONS_COVERED'),
      deductible: formatPrice(getBenefitLimit(policy, 'DEDUCTIBLE')),
      deductibleUsed: getBenefitUsed(policy, 'DEDUCTIBLE'),
      maxBenefit: getBenefitLimit(policy, 'ALLOWANCE'),
      maxBenefitUsed: getBenefitUsed(policy, 'ALLOWANCE'),
      maternityCoverage: doesBenefitExist(policy, 'MATERNITY_COVERED'),
      insuranceProduct: policy?.insuranceProduct,
    }

    // While these are technically "user" properties, the way Heap tracks user
    // properties doesn't allow us to track them over time. To Heap a user
    // property is something that would NEVER change. In these cases, any of
    // these properties can and will change at some point and so our only
    // choice is to store them as event properties.
    window.heap.clearEventProperties()
    window.heap.addEventProperties(collectedData)
  }, [authedUser, policy])
}
